import { useEffect } from 'react';

type FiltersObject = Record<
  string,
  string | number | boolean | null | undefined
>;

interface UseSyncQueryParamsOptions {
  replace?: boolean; // whether to use replaceState instead of pushState
}

/**
 * Syncs a filters object to the browser URL as query params.
 */
export function useQueryParams(
  filters: FiltersObject,
  options: UseSyncQueryParamsOptions = {}
) {
  const { replace = true } = options;

  useEffect(() => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (
        value === undefined ||
        value === null ||
        value === '' ||
        value === false
      ) {
        searchParams.delete(key);
      } else {
        searchParams.set(key, String(value));
      }
    });

    url.search = searchParams.toString();
    if (replace) {
      window.history.replaceState({}, '', url);
    } else {
      window.history.pushState({}, '', url);
    }
  }, [JSON.stringify(filters)]);
  //stringify ensures effect triggers when any nested value changes
}
